module.exports = __webpack_public_path__ + "img/pic_1.21ae2596.jpg";